import { render, staticRenderFns } from "./OffencesCards.vue?vue&type=template&id=a425e43a"
import script from "./OffencesCards.vue?vue&type=script&lang=js"
export * from "./OffencesCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports